export default __webpack_public_path__ + "static/media/frown.b060bcb7.svg";